"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.now = now;
exports.to_unix_timestamp = to_unix_timestamp;
function now() {
    return to_unix_timestamp(new Date());
}
function to_unix_timestamp(d) {
    return Math.floor(d.getTime() / 1000);
}
